import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const periodChargerStatQueryKeys = {
  all: ['periodChargerStats'],
  twoWeeks: (params) => [...periodChargerStatQueryKeys.all, 'twoWeeks', params],
  twoWeek: (params) => [...periodChargerStatQueryKeys.twoWeeks(params)],
  oneYears: (params) => [...periodChargerStatQueryKeys.all, 'oneYears', params],
  oneYear: (params) => [...periodChargerStatQueryKeys.oneYears(params)],
};


export const usePeriodChargerStatTwoWeeks = (id, today) => {
  return useQuery({
    queryKey: periodChargerStatQueryKeys.twoWeeks(id),
    queryFn: async () => {
      const response = await api.get(`/drivecore/stat/api/TwoWeeksChargerStat?chargerSysId=${id}&referenceDateStr=${today}`);
      return response || null;
    },
  });
};

export const usePeriodChargerStatOneYear = (id, today) => {
  return useQuery({
    queryKey: periodChargerStatQueryKeys.oneYear(id),
    queryFn: async () => {
      const response = await api.get(`/drivecore/stat/api/OneYearChargerStat?chargerSysId=${id}&referenceDateStr=${today}`);
      return response || null;
    },
  });
};